// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#barquettes {\n  position: absolute;\n  z-index: 2;\n  background: white;\n  border: 1px solid black;\n  border-radius: 3.5px;\n  padding: 8px;\n}\n#barquettes td.erreur {\n  border: 1px solid red;\n}\n", ""]);
// Exports
module.exports = exports;
